import * as yup from "yup";

const loginAccountScheme = yup.object().shape({
  username: yup
    .string()
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Invalid email address",
    )
    .required("Email Id is required"),
  password: yup.string().required("Password is required"),
});

export default loginAccountScheme;
